// ============================================
// Core Domain Types for Website Risk Monitor
// ============================================
// Error Codes
export const ErrorCodes = {
    UNAUTHORIZED: 'UNAUTHORIZED',
    AUTH_REQUIRED: 'AUTH_REQUIRED',
    AUTH_INVALID: 'AUTH_INVALID',
    AUTH_EXPIRED: 'AUTH_EXPIRED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    RATE_LIMITED: 'RATE_LIMITED',
    SCAN_LIMIT_REACHED: 'SCAN_LIMIT_REACHED',
    WEBSITE_LIMIT_REACHED: 'WEBSITE_LIMIT_REACHED',
    INVALID_URL: 'INVALID_URL',
    BLOCKED_URL: 'BLOCKED_URL',
    SCAN_TIMEOUT: 'SCAN_TIMEOUT',
    SCAN_FAILED: 'SCAN_FAILED',
    PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
export const TIER_CONFIGS = {
    free: {
        name: 'free',
        priceMonthly: 0,
        websiteLimit: 1,
        scansPerMonth: 3,
        scanFrequency: 'monthly',
        pdfReports: false,
        emailAlerts: false,
        dataRetentionDays: 30,
    },
    starter: {
        name: 'starter',
        priceMonthly: 29,
        websiteLimit: 1,
        scansPerMonth: 'unlimited',
        scanFrequency: 'weekly',
        pdfReports: true,
        emailAlerts: true,
        dataRetentionDays: 365,
    },
    professional: {
        name: 'professional',
        priceMonthly: 79,
        websiteLimit: 5,
        scansPerMonth: 'unlimited',
        scanFrequency: 'daily',
        pdfReports: true,
        emailAlerts: true,
        dataRetentionDays: 730,
    },
    enterprise: {
        name: 'enterprise',
        priceMonthly: 199,
        websiteLimit: 25,
        scansPerMonth: 'unlimited',
        scanFrequency: 'on_demand',
        pdfReports: true,
        emailAlerts: true,
        dataRetentionDays: 'unlimited',
    },
};
// ============================================
// Category Weights
// ============================================
export const CATEGORY_WEIGHTS = {
    security: 0.35,
    performance: 0.25,
    compliance: 0.2,
    technical: 0.2,
};
//# sourceMappingURL=index.js.map